// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-container.aluminium-page {
  width: 100%;
  max-width: 1600px;
}

.aluminium-upload-panel {
  position: relative;
  z-index: 1;
}

.aluminium-currency-decision {
  margin: 0 0 20px;
  padding: 16px 18px;
  border: 1px solid #bfdbfe;
  border-radius: 10px;
  background: #eff6ff;
}

.aluminium-currency-decision legend {
  padding: 0 6px;
  color: #172033;
  font-weight: 700;
}

.aluminium-currency-options,
.aluminium-currency-conversion {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.aluminium-currency-options label,
.aluminium-currency-conversion label {
  display: flex;
  align-items: center;
  gap: 7px;
}

.aluminium-currency-conversion {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid #bfdbfe;
}

.aluminium-original-values {
  margin-bottom: 24px;
}

.aluminium-notes-editor {
  display: grid;
  gap: 7px;
  max-width: 720px;
  margin: 10px 0 18px;
}

.aluminium-notes-editor label {
  font-weight: 600;
}

.aluminium-notes-editor textarea {
  box-sizing: border-box;
  width: 100%;
  min-height: 110px;
  padding: 10px 12px;
  border: 1px solid #cbd5e1;
  border-radius: 7px;
  font: inherit;
  resize: vertical;
}

.aluminium-notes-editor small,
.aluminium-notes-hint {
  color: #64748b;
}

.aluminium-converted-original {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  white-space: nowrap;
}

.aluminium-converted-original small {
  color: #64748b;
  font-size: 11px;
}

.aluminium-automation-title {
  margin: 0 0 4px;
  color: #172033;
}

.aluminium-automation-description {
  margin: 0 0 18px;
  color: #64748b;
  font-size: 14px;
}

.aluminium-faq h3 {
  margin: 0 0 14px;
}

.aluminium-faq details {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 12px 14px;
  background: #f8fafc;
}

.aluminium-faq summary {
  color: #172033;
  cursor: pointer;
  font-weight: 700;
}

.aluminium-faq p {
  margin: 12px 0 0;
  color: #475569;
}

.aluminium-module-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
}

.aluminium-module-header > div:first-child {
  min-width: 0;
}

.aluminium-montage-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
}

.aluminium-montage-heading h3,
.aluminium-montage-heading p {
  margin-top: 0;
}

.aluminium-montage-heading p {
  color: #64748b;
  font-size: 14px;
}

.aluminium-region-switcher {
  display: flex;
  flex: 0 0 auto;
  gap: 8px;
}

.aluminium-montage-total {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin: 18px 0;
  padding: 16px 18px;
  border-radius: 9px;
  background: #eff6ff;
  color: #1e3a8a;
}

.aluminium-montage-total strong {
  font-size: 20px;
}

.aluminium-montage-table-wrap {
  overflow-x: auto;
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
}

.aluminium-montage-table {
  width: 100%;
  min-width: 1240px;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 12.5px;
  font-variant-numeric: tabular-nums;
}

.aluminium-montage-table caption {
  padding: 13px 16px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #1e293b;
  font-size: 14px;
  font-weight: 700;
  text-align: left;
}

.aluminium-montage-table th,
.aluminium-montage-table td {
  padding: 12px 10px;
  border-bottom: 1px solid #e2e8f0;
  text-align: right;
  vertical-align: middle;
}

.aluminium-montage-table thead th {
  padding-top: 13px;
  padding-bottom: 13px;
  border-bottom-color: #1e3a8a;
  background: #1e3a8a;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.aluminium-montage-table th:first-child,
.aluminium-montage-table td:first-child,
.aluminium-montage-table th:nth-child(2),
.aluminium-montage-table td:nth-child(2),
.aluminium-montage-table th:nth-child(5),
.aluminium-montage-table td:nth-child(5),
.aluminium-montage-table th:nth-child(6),
.aluminium-montage-table td:nth-child(6) { text-align: left; }

.aluminium-montage-table tbody tr:nth-child(odd) td { background: #fff; }
.aluminium-montage-table tbody tr:nth-child(even) td { background: #f8fafc; }
.aluminium-montage-table tbody tr:hover td { background: #eef6ff; }
.aluminium-montage-table tbody td:first-child {
  position: sticky;
  left: 0;
  z-index: 1;
  min-width: 74px;
  box-shadow: inset -1px 0 #e2e8f0;
}
.aluminium-montage-table thead th:first-child { position: sticky; left: 0; z-index: 2; }
.aluminium-montage-table tbody td:first-child strong {
  display: inline-block;
  padding: 5px 8px;
  border-radius: 6px;
  background: #e8efff;
  color: #1e40af;
  font-size: 13px;
  white-space: nowrap;
}
.aluminium-montage-table tbody td:nth-child(10) { color: #0f172a; font-weight: 700; white-space: nowrap; }
.aluminium-montage-table tbody tr:last-child td { border-bottom: 0; }

.aluminium-montage-table td:first-child small {
  display: block;
  margin-top: 4px;
  color: #64748b;
  font-size: 11px;
}

.aluminium-montage-table select {
  width: 100%;
  min-width: 110px;
  min-height: 38px;
  padding: 7px 9px;
  border: 1px solid #cbd5e1;
  border-radius: 7px;
  background: #fff;
  color: #172033;
}
.aluminium-montage-table input:focus-visible,
.aluminium-montage-table select:focus-visible { outline: 3px solid rgba(37, 99, 235, 0.2); outline-offset: 2px; }
.aluminium-montage-table select:disabled { background: #f1f5f9; color: #64748b; }

@media (max-width: 760px) {
  .aluminium-montage-heading {
    flex-direction: column;
  }

  .aluminium-region-switcher {
    width: 100%;
    flex-wrap: wrap;
  }
}

.aluminium-file-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  box-sizing: border-box;
  padding: 11px 18px;
  border: 0;
  border-radius: 7px;
  background: #2563eb;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.12);
}

.aluminium-file-button:hover {
  background: #1d4ed8;
}

.aluminium-file-button:focus-within {
  outline: 3px solid rgba(37, 99, 235, 0.28);
  outline-offset: 2px;
}

.aluminium-file-button.disabled {
  opacity: 0.65;
  cursor: wait;
}

.aluminium-visually-hidden-input {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.aluminium-selected-file {
  max-width: min(420px, 100%);
  overflow: hidden;
  color: #334155;
  font-size: 14px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.aluminium-page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.aluminium-section-nav {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 18px;
  padding: 8px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
}

.aluminium-section-link {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  min-height: 46px;
  padding: 10px 14px;
  border-radius: 8px;
  color: #475569;
  font-size: 14px;
  font-weight: 700;
  text-align: center;
  text-decoration: none;
  transition: background 0.18s ease, color 0.18s ease, box-shadow 0.18s ease;
}

.aluminium-section-link:hover,
.aluminium-section-link:focus-visible {
  background: #eff6ff;
  color: #1d4ed8;
  outline: none;
}

.aluminium-section-link.active {
  background: #2563eb;
  color: #fff;
  box-shadow: 0 3px 9px rgba(37, 99, 235, 0.22);
}

.aluminium-coming-soon p {
  margin: 5px 0 18px;
  color: #64748b;
  font-size: 14px;
}

.aluminium-coming-soon-notice {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 20px;
  padding: 18px;
  border: 1px solid #fde68a;
  border-radius: 10px;
  background: #fffbeb;
  color: #92400e;
}

.aluminium-coming-soon-notice > svg {
  width: 28px;
  height: 28px;
  flex: 0 0 auto;
}

.aluminium-coming-soon-notice div {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.aluminium-coming-soon-notice span {
  font-size: 14px;
}

.aluminium-changes-notice {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin: 0 0 20px;
  padding: 14px 16px;
  border: 1px solid #fecaca;
  border-left: 4px solid #dc2626;
  border-radius: 9px;
  background: #fef2f2;
  color: #7f1d1d;
  box-shadow: 0 2px 7px rgba(127, 29, 29, 0.06);
}

.aluminium-changes-notice > svg {
  width: 20px;
  height: 20px;
  flex: 0 0 auto;
  margin-top: 1px;
  color: #dc2626;
}

.aluminium-changes-notice > div {
  min-width: 0;
}

.aluminium-changes-notice strong {
  display: block;
  color: #b91c1c;
  font-size: 15px;
  line-height: 1.3;
}

.aluminium-changes-notice time {
  display: inline-block;
  margin-top: 5px;
  padding: 2px 7px;
  border-radius: 5px;
  background: #fee2e2;
  color: #991b1b;
  font-size: 12px;
  font-weight: 700;
}

.aluminium-changes-notice span {
  display: block;
  margin-top: 8px;
  color: #991b1b;
  font-size: 14px;
  font-weight: 700;
}

.aluminium-changes-notice ul {
  margin: 5px 0 0;
  padding-left: 20px;
  color: #991b1b;
  font-size: 14px;
  line-height: 1.5;
}

.aluminium-changes-notice li + li {
  margin-top: 3px;
}

.aluminium-coming-soon button:disabled {
  opacity: 0.55;
  cursor: not-allowed !important;
}

.aluminium-instruction-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
}

.aluminium-instruction-button,
.aluminium-instruction-download {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 14px;
  border: 1px solid #2563eb;
  border-radius: 7px;
  background: #fff;
  color: #1d4ed8;
  font: inherit;
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
}

.aluminium-instruction-button:hover,
.aluminium-instruction-download:hover {
  background: #eff6ff;
}

.aluminium-instruction-button:disabled,
.aluminium-instruction-download:disabled {
  border-color: #cbd5e1;
  background: #f1f5f9;
  color: #64748b;
  cursor: not-allowed;
}

.aluminium-instruction-overlay {
  position: fixed;
  z-index: 11000;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.68);
}

.aluminium-instruction-modal {
  display: flex;
  flex-direction: column;
  width: min(1100px, 96vw);
  height: min(900px, 92vh);
  overflow: hidden;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.35);
}

.aluminium-instruction-modal-header,
.aluminium-instruction-modal-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 18px;
}

.aluminium-instruction-modal-header {
  border-bottom: 1px solid #e2e8f0;
}

.aluminium-instruction-modal-header h3 {
  margin: 0;
}

.aluminium-instruction-modal-footer {
  justify-content: flex-end;
  border-top: 1px solid #e2e8f0;
}

.aluminium-instruction-close {
  width: 38px;
  height: 38px;
  border: 0;
  border-radius: 50%;
  background: #f1f5f9;
  color: #334155;
  font-size: 26px;
  line-height: 1;
  cursor: pointer;
}

.aluminium-instruction-close:hover {
  background: #e2e8f0;
}

.aluminium-instruction-frame {
  width: 100%;
  flex: 1 1;
  border: 0;
  background: #f8fafc;
}

.aluminium-changed-toast {
  position: fixed;
  z-index: 10000;
  top: 86px;
  left: 50%;
  transform: translateX(-50%);
  min-width: 180px;
  padding: 14px 24px;
  border-radius: 10px;
  background: #15803d;
  color: #fff;
  box-shadow: 0 10px 28px rgba(21, 128, 61, 0.28);
  text-align: center;
  font-size: 17px;
  font-weight: 800;
  animation: aluminium-toast-in 0.2s ease-out;
}

@keyframes aluminium-toast-in {
  from { opacity: 0; transform: translate(-50%, -10px); }
  to { opacity: 1; transform: translate(-50%, 0); }
}

.aluminium-config-panel {
  min-width: 0;
}

.aluminium-mode-switcher {
  display: grid;
  grid-template-columns: repeat(3, minmax(180px, 1fr));
  gap: 12px;
  margin: 22px 0 16px;
}

.aluminium-workflow-switcher {
  grid-template-columns: repeat(2, minmax(220px, 1fr));
}

.aluminium-config-panel {
  display: flex;
  flex-direction: column;
}

.aluminium-workflow-content {
  order: 1;
}

.aluminium-original-values-summary {
  order: 2;
}

.aluminium-workflow-details {
  order: 3;
}

.aluminium-config-panel > .aluminium-inline-preview {
  order: 4;
}

.aluminium-pricing-step {
  margin-top: 22px;
  padding: 22px;
  border: 1px solid #dbe4f0;
  border-radius: 12px;
  background: #fff;
}

.aluminium-step-heading {
  display: flex;
  align-items: baseline;
  gap: 12px;
}

.aluminium-step-heading span {
  padding: 5px 9px;
  border-radius: 999px;
  background: #dbeafe;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
}

.aluminium-step-heading h3 {
  margin: 0;
}

.aluminium-pricing-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
}

.aluminium-mode-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  min-height: 58px;
  padding: 12px 16px;
  border: 2px solid #d7e0ec;
  border-radius: 10px;
  background: #f8fafc;
  color: #263447;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
}

.aluminium-mode-button:hover {
  border-color: #8eacf8;
  background: #f1f5ff;
}

.aluminium-mode-button.active {
  border-color: #2563eb;
  background: #eaf1ff;
  color: #1747b7;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
}

.aluminium-value-controls {
  display: flex;
  justify-content: center;
  align-items: end;
  flex-wrap: wrap;
  gap: 20px;
  padding: 14px;
  border-radius: 10px;
  background: #f8fafc;
}

.aluminium-value-controls label {
  display: flex;
  align-items: center;
  gap: 9px;
  font-weight: 700;
}

.aluminium-discount-controls {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px;
}

.aluminium-discount-controls label {
  justify-content: center;
  min-width: 0;
  white-space: nowrap;
}

.aluminium-discount-controls input,
.aluminium-discount-controls select {
  box-sizing: border-box;
  width: 108px;
  max-width: none !important;
  height: 38px;
  flex: 0 0 108px;
  background: #fff;
}

.aluminium-discount-controls .aluminium-exchange-rate {
  gap: 7px;
}

.aluminium-discount-controls .aluminium-exchange-rate select {
  width: 88px;
  flex-basis: 88px;
}

.aluminium-auto-discount {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: fit-content;
  margin: 18px auto 6px;
  padding: 12px 14px 12px 20px;
  border: 1px solid #b9cdfc;
  border-radius: 11px;
  background: #f3f7ff;
  color: #263447;
  font-size: 16px;
  font-weight: 700;
}

.aluminium-auto-discount strong {
  min-width: 112px;
  padding: 9px 14px;
  border-radius: 7px;
  background: #2563eb;
  color: #fff;
  text-align: center;
  font-size: 19px;
  letter-spacing: 0.02em;
}

.aluminium-auto-markup {
  border-color: #bbf7d0;
  background: #f0fdf4;
}

.aluminium-auto-markup strong {
  background: #15803d;
}

.aluminium-inline-preview {
  margin-top: 28px;
  padding-top: 24px;
  border-top: 1px solid #e2e8f0;
}

.aluminium-result-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 14px;
}

.aluminium-finish-button {
  padding: 11px 22px;
  border: 1px solid #94a3b8;
  border-radius: 7px;
  background: #fff;
  color: #334155;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.aluminium-finish-button:hover {
  border-color: #64748b;
  background: #f1f5f9;
}

.aluminium-pdf-frame {
  display: block;
  width: 100%;
  height: min(76vh, 900px);
  min-height: 620px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #f8fafc;
}

@media (max-width: 1350px) {
  .aluminium-pdf-frame {
    height: 720px;
  }
}

@media (max-width: 700px) {
  .aluminium-section-nav {
    grid-template-columns: 1fr;
  }

  .aluminium-section-link {
    justify-content: flex-start;
  }

  .aluminium-page-header,
  .aluminium-module-header,
  .aluminium-instruction-actions {
    align-items: stretch;
    flex-direction: column;
  }

  .aluminium-instruction-overlay {
    padding: 8px;
  }

  .aluminium-instruction-modal {
    width: 100%;
    height: 96vh;
  }

  .aluminium-result-actions {
    align-items: stretch;
    flex-direction: column;
  }

  .aluminium-mode-switcher {
    grid-template-columns: 1fr;
  }

  .aluminium-pricing-step {
    padding: 14px;
  }

  .aluminium-pricing-actions {
    align-items: stretch;
    flex-direction: column;
  }

  .aluminium-auto-discount {
    width: 100%;
    flex-direction: column;
    padding: 14px;
  }

  .aluminium-pdf-frame {
    height: 560px;
    min-height: 0;
  }
}
.aluminium-dimensions { display: flex; align-items: center; gap: 5px; min-width: 190px; }
.aluminium-dimensions input { box-sizing: border-box; width: 82px; min-height: 38px; padding: 7px; border: 1px solid #cbd5e1; border-radius: 6px; }
.aluminium-dimensions.requires-review input { border-color: #f59e0b; background: #fffbeb; box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.16); }
.aluminium-dimensions-warning { display: block; margin-top: 4px; color: #b45309; font-size: 11px; font-weight: 700; text-align: left; }
.aluminium-montage-table select.requires-selection { border-color: #dc2626; background: #fef2f2; color: #991b1b; font-weight: 700; }
.aluminium-montage-table input.requires-selection { border-color: #dc2626; background: #fef2f2; color: #991b1b; font-weight: 700; }
.aluminium-quantity-input { box-sizing: border-box; width: 64px; min-height: 38px; padding: 7px; border: 1px solid #cbd5e1; border-radius: 6px; text-align: right; }
.aluminium-montage-table td:nth-child(7) .aluminium-quantity-input { width: 94px; }
.aluminium-row-actions { display: flex; justify-content: flex-end; gap: 6px; flex-wrap: wrap; min-width: 80px; }
.aluminium-row-actions button { border: 1px solid #2563eb; border-radius: 6px; padding: 6px 8px; background: #eff6ff; color: #1d4ed8; cursor: pointer; white-space: nowrap; }
.aluminium-row-actions button:hover:not(:disabled) { background: #dbeafe; }
.aluminium-row-actions button:focus-visible { outline: 3px solid rgba(37, 99, 235, 0.25); outline-offset: 2px; }
.aluminium-row-actions button:disabled { opacity: 0.5; cursor: not-allowed; }
.aluminium-row-actions button.add { width: 30px; height: 30px; padding: 0; font-size: 20px; line-height: 1; font-weight: 700; }
.aluminium-row-actions button.remove { border-color: #dc2626; background: #fef2f2; color: #b91c1c; }
.aluminium-row-actions button.remove:hover:not(:disabled) { background: #fee2e2; }
.aluminium-montage-table tbody tr.aluminium-service-row td { background: #eef2ff; color: #334155; }
.aluminium-montage-table tbody tr.aluminium-service-row:hover td { background: #e0e7ff; }
.aluminium-montage-table tbody tr.aluminium-service-row td:first-child strong { background: #dbeafe; }
.aluminium-montage-table tbody tr.aluminium-position-start td { border-top: 2px solid #bfdbfe; }
.aluminium-montage-summary-title { margin: 20px 0 10px; }
.aluminium-common-installation {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(260px, 360px);
  align-items: center;
  gap: 24px;
  margin: 8px 0 22px;
  padding: 20px 24px;
  overflow: hidden;
  border: 1px solid #bfdbfe;
  border-radius: 14px;
  background: linear-gradient(110deg, #eff6ff 0%, #f8fbff 72%, #fff 100%);
  box-shadow: 0 8px 24px rgba(30, 64, 175, 0.07);
}
.aluminium-common-installation::before {
  position: absolute;
  inset: 0 auto 0 0;
  width: 5px;
  background: #2563eb;
  content: '';
}
.aluminium-common-installation h4 { margin: 0 0 6px; color: #1e3a8a; font-size: 18px; }
.aluminium-common-installation p { margin: 0; color: #475569; font-size: 13px; }
.aluminium-common-installation-field { display: grid; min-width: 0; gap: 7px; }
.aluminium-common-installation label { color: #334155; font-size: 13px; font-weight: 700; }
.aluminium-common-installation select {
  width: 100%;
  min-height: 44px;
  padding: 9px 12px;
  border: 1px solid #93c5fd;
  border-radius: 9px;
  background: #fff;
  color: #172033;
  font: inherit;
  font-weight: 600;
}
.aluminium-common-installation select:focus-visible { outline: 3px solid rgba(37, 99, 235, 0.25); outline-offset: 2px; }
.aluminium-mixed-construction-alert {
  margin: 18px 0;
  padding: 16px 18px;
  border: 1px solid #fca5a5;
  border-left: 5px solid #dc2626;
  border-radius: 10px;
  background: #fef2f2;
  color: #991b1b;
  line-height: 1.5;
}
.aluminium-mixed-construction-alert > strong { display: block; margin-bottom: 8px; font-size: 15px; }
.aluminium-mixed-construction-alert ul { margin: 0; padding-left: 20px; }
.aluminium-mixed-construction-alert li + li { margin-top: 8px; }
.aluminium-montage-legend {
  display: flex;
  align-items: center;
  gap: 10px 18px;
  flex-wrap: wrap;
  margin: 12px 0 0;
  padding: 10px 14px;
  border: 1px solid #cbd5e1;
  border-radius: 9px;
  background: #f8fafc;
  color: #334155;
  font-size: 13px;
}
.aluminium-montage-legend span { display: inline-flex; align-items: center; gap: 6px; }
.aluminium-montage-legend code { padding: 2px 6px; border-radius: 5px; background: #e0e7ff; color: #1e40af; font-weight: 700; }
.aluminium-montage-legend small { color: #64748b; }
.aluminium-montage-financials { display: grid; grid-template-columns: repeat(3, minmax(140px, 1fr)); gap: 12px; margin-bottom: 18px; }
.aluminium-montage-financials > div { padding: 14px; border-radius: 9px; background: #f1f5f9; }
.aluminium-montage-financials span, .aluminium-montage-financials strong { display: block; }
.aluminium-montage-financials strong { margin-top: 4px; font-size: 18px; }
.aluminium-montage-financials.discounted > div { background: #ecfdf5; }
.aluminium-montage-discount { margin-top: 24px; padding-top: 20px; border-top: 2px solid #cbd5e1; }
.aluminium-additional-services {
  margin-top: 26px;
  padding: 22px;
  border: 1px solid #a5b4fc;
  border-top: 4px solid #4f46e5;
  border-radius: 14px;
  background: linear-gradient(180deg, #eef2ff 0%, #f8faff 30%, #fff 100%);
  box-shadow: 0 10px 28px rgba(49, 46, 129, 0.09);
}
.aluminium-additional-services-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 18px;
}
.aluminium-additional-services-heading h4 { margin: 0 0 5px; color: #312e81; font-size: 19px; }
.aluminium-additional-services-heading p { margin: 0; color: #475569; font-size: 13px; }
.aluminium-additional-services-heading > span {
  flex: 0 0 auto;
  padding: 5px 9px;
  border: 1px solid #c7d2fe;
  border-radius: 999px;
  background: #fff;
  color: #4338ca;
  font-size: 12px;
  font-weight: 700;
}
.aluminium-additional-services-grid { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 12px; align-items: stretch; }
.aluminium-additional-services .aluminium-service-card {
  min-width: 0;
  margin: 0;
  padding: 14px;
  border: 1px solid #dbe3f0;
  border-radius: 11px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
}
.aluminium-additional-services .aluminium-service-card legend {
  max-width: 100%;
  padding: 0 5px;
  color: #1e293b;
  font-size: 14px;
  font-weight: 750;
}
.aluminium-service-card legend span { color: #4f46e5; }
.aluminium-service-card > p { min-height: 34px; margin: 4px 0 14px; color: #64748b; font-size: 12px; line-height: 1.45; }
.aluminium-service-options { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 7px; }
.aluminium-service-included {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 38px;
  padding: 6px 8px;
  border: 1px solid #86efac;
  border-radius: 8px;
  background: #f0fdf4;
  color: #166534;
  font-size: 13px;
  font-weight: 700;
}
.aluminium-additional-services .aluminium-service-options label {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 38px;
  padding: 6px 8px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #f8fafc;
  color: #334155;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}
.aluminium-service-options label:has(input:checked) { border-color: #6366f1; background: #eef2ff; color: #3730a3; box-shadow: inset 0 0 0 1px #6366f1; }
.aluminium-service-options label:has(input:disabled) { opacity: 0.5; cursor: not-allowed; }
.aluminium-service-options input { margin: 0; accent-color: #4f46e5; }
.aluminium-service-options label:focus-within { outline: 3px solid rgba(99, 102, 241, 0.2); outline-offset: 2px; }
.aluminium-transport-controls { display: grid; gap: 10px; margin-top: 14px; padding-top: 14px; border-top: 1px solid #e2e8f0; }
.aluminium-additional-services .aluminium-transport-controls label { display: grid; min-width: 0; gap: 5px; color: #334155; font-size: 12px; font-weight: 700; }
.aluminium-transport-controls select, .aluminium-transport-controls input { box-sizing: border-box; width: 100%; min-width: 0; min-height: 38px; padding: 7px 9px; border: 1px solid #cbd5e1; border-radius: 7px; background: #fff; color: #172033; }
.aluminium-transport-controls select:focus-visible, .aluminium-transport-controls input:focus-visible { outline: 3px solid rgba(99, 102, 241, 0.2); outline-offset: 2px; }
.aluminium-transport-controls p { margin: 0; color: #64748b; font-size: 12px; line-height: 1.5; }
.aluminium-transport-controls p.aluminium-form-error { color: #b91c1c; }
.aluminium-service-card > p.aluminium-service-hint { min-height: 0; margin: 12px 0 0; color: #92400e; }
.aluminium-additional-services > p { margin: 14px 0 0; }
.aluminium-service-summary { display: grid; grid-auto-flow: column; grid-auto-columns: minmax(180px, 1fr); gap: 12px; overflow-x: auto; margin: 14px 0; }
.aluminium-service-summary > div { min-width: 0; padding: 12px 14px; border-radius: 8px; background: #f1f5f9; }
.aluminium-service-summary span, .aluminium-service-summary strong { display: block; }
.aluminium-service-summary strong { margin-top: 4px; }
.aluminium-montage-effective-discount { color: #166534; }
.aluminium-form-error { color: #b91c1c; }
.aluminium-updates { display: grid; gap: 10px; margin-top: 12px; }
.aluminium-updates p { display: grid; grid-template-columns: 155px minmax(0, 1fr); gap: 12px; margin: 0; padding: 10px 12px; border-left: 3px solid #2563eb; border-radius: 6px; background: #f8fafc; color: #334155; }
.aluminium-updates time { color: #64748b; font-size: 0.9em; font-weight: 700; white-space: nowrap; }
.aluminium-recipient-option { display: flex; align-items: center; gap: 10px; margin: 12px 0 24px; color: #334155; font-size: 0.9em; }
.aluminium-recipient-option input[type="checkbox"] { width: 22px; height: 22px; margin: 0; flex: 0 0 22px; cursor: pointer; }
.aluminium-discount-language { margin: -8px 0 24px 32px; }
.aluminium-discount-language label { display: flex; align-items: center; flex-wrap: wrap; gap: 10px; color: #334155; font-size: 0.9em; font-weight: 700; }
.aluminium-discount-language select { max-width: 310px !important; background: #fff; }
.aluminium-discount-summary { margin-top: 24px; }
@media (max-width: 600px) { .aluminium-updates p { grid-template-columns: 1fr; gap: 4px; } }
@media (max-width: 640px) { .aluminium-montage-financials { grid-template-columns: 1fr; } }
@media (max-width: 1200px) { .aluminium-additional-services-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
@media (max-width: 700px) {
  .aluminium-common-installation { grid-template-columns: 1fr; gap: 14px; padding: 18px; }
  .aluminium-additional-services { padding: 18px; }
  .aluminium-additional-services-heading { flex-direction: column; }
  .aluminium-additional-services-grid { grid-template-columns: 1fr; }
}
.aluminium-export-row { display: flex; align-items: flex-start; flex-wrap: wrap; gap: 12px; margin-top: 18px; }
.aluminium-export-validation { flex: 1 1 320px; padding: 10px 14px; border: 1px solid #fecaca; border-radius: 8px; background: #fef2f2; color: #991b1b; font-size: 13px; line-height: 1.45; }
.aluminium-export-validation ul { margin: 6px 0 0; padding-left: 18px; }
.aluminium-pdf-discount-option {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-top: 18px;
  padding: 11px 14px;
  border: 1px solid #cbd5e1;
  border-radius: 9px;
  background: #f8fafc;
  color: #1e293b;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
.aluminium-pdf-discount-option input { width: 18px; height: 18px; margin: 0; accent-color: #2563eb; cursor: pointer; }
.aluminium-pdf-discount-option:focus-within { outline: 3px solid rgba(37, 99, 235, 0.2); outline-offset: 2px; }
.aluminium-pdf-discount-option:has(input:disabled) { opacity: 0.6; cursor: not-allowed; }
.aluminium-pdf-discount-option:has(input:disabled) input { cursor: not-allowed; }
.aluminium-pdf-discount-option + .aluminium-export-row { margin-top: 12px; }
.aluminium-export-loading { display: inline-flex; align-items: center; gap: 8px; color: #1d4ed8; font-weight: 600; }
.aluminium-spinner { width: 17px; height: 17px; border: 2px solid #bfdbfe; border-top-color: #2563eb; border-radius: 50%; animation: aluminium-spin .8s linear infinite; }
.aluminium-preview-heading { display: flex; align-items: center; justify-content: space-between; gap: 12px; flex-wrap: wrap; }
.aluminium-preview-switcher { display: flex; gap: 8px; }
.aluminium-preview-switcher button { padding: 7px 10px; border: 1px solid #2563eb; border-radius: 6px; background: #eff6ff; color: #1d4ed8; cursor: pointer; }
.aluminium-preview-switcher button:disabled { border-color: #cbd5e1; background: #f1f5f9; color: #64748b; cursor: default; }
@keyframes aluminium-spin { to { transform: rotate(360deg); } }
`, "",{"version":3,"sources":["webpack://./src/pages/css/AluminiumDeals.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,4BAA4B;EAC5B,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;;;;2CAO2C,gBAAgB,EAAE;;AAE7D,sDAAsD,gBAAgB,EAAE;AACxE,uDAAuD,mBAAmB,EAAE;AAC5E,6CAA6C,mBAAmB,EAAE;AAClE;EACE,gBAAgB;EAChB,OAAO;EACP,UAAU;EACV,eAAe;EACf,gCAAgC;AAClC;AACA,gDAAgD,gBAAgB,EAAE,OAAO,EAAE,UAAU,EAAE;AACvF;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA,kDAAkD,cAAc,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AACzG,kDAAkD,gBAAgB,EAAE;;AAEpE;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;gDACgD,yCAAyC,EAAE,mBAAmB,EAAE;AAChH,2CAA2C,mBAAmB,EAAE,cAAc,EAAE;;AAEhF;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,0EAA0E;AAC5E;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,SAAS;AACX;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,SAAO;EACP,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,+CAA+C;EAC/C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE,iCAAiC,EAAE;EACtD,KAAK,UAAU,EAAE,6BAA6B,EAAE;AAClD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mGAAmG;AACrG;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,0BAA0B;EAC1B,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,wBAAwB;EACxB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;;IAGE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,aAAa;EACf;AACF;AACA,wBAAwB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AACxF,8BAA8B,sBAAsB,EAAE,WAAW,EAAE,gBAAgB,EAAE,YAAY,EAAE,yBAAyB,EAAE,kBAAkB,EAAE;AAClJ,8CAA8C,qBAAqB,EAAE,mBAAmB,EAAE,8CAA8C,EAAE;AAC1I,gCAAgC,cAAc,EAAE,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACtI,qDAAqD,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACnI,oDAAoD,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAClI,4BAA4B,sBAAsB,EAAE,WAAW,EAAE,gBAAgB,EAAE,YAAY,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE;AACnK,qEAAqE,WAAW,EAAE;AAClF,yBAAyB,aAAa,EAAE,yBAAyB,EAAE,QAAQ,EAAE,eAAe,EAAE,eAAe,EAAE;AAC/G,gCAAgC,yBAAyB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,cAAc,EAAE,eAAe,EAAE,mBAAmB,EAAE;AAC5K,qDAAqD,mBAAmB,EAAE;AAC1E,8CAA8C,0CAA0C,EAAE,mBAAmB,EAAE;AAC/G,yCAAyC,YAAY,EAAE,mBAAmB,EAAE;AAC5E,oCAAoC,WAAW,EAAE,YAAY,EAAE,UAAU,EAAE,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAC9H,uCAAuC,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AACnG,4DAA4D,mBAAmB,EAAE;AACjF,6DAA6D,mBAAmB,EAAE,cAAc,EAAE;AAClG,mEAAmE,mBAAmB,EAAE;AACxF,gFAAgF,mBAAmB,EAAE;AACrG,gEAAgE,6BAA6B,EAAE;AAC/F,mCAAmC,mBAAmB,EAAE;AACxD;EACE,kBAAkB;EAClB,aAAa;EACb,0DAA0D;EAC1D,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,uEAAuE;EACvE,8CAA8C;AAChD;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,mBAAmB;EACnB,WAAW;AACb;AACA,oCAAoC,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AACtF,mCAAmC,SAAS,EAAE,cAAc,EAAE,eAAe,EAAE;AAC/E,uCAAuC,aAAa,EAAE,YAAY,EAAE,QAAQ,EAAE;AAC9E,uCAAuC,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC1F;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;AACA,sDAAsD,0CAA0C,EAAE,mBAAmB,EAAE;AACvH;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA,+CAA+C,cAAc,EAAE,kBAAkB,EAAE,eAAe,EAAE;AACpG,yCAAyC,SAAS,EAAE,kBAAkB,EAAE;AACxE,8CAA8C,eAAe,EAAE;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA,iCAAiC,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACtF,iCAAiC,gBAAgB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AAC9H,kCAAkC,cAAc,EAAE;AAClD,gCAAgC,aAAa,EAAE,oDAAoD,EAAE,SAAS,EAAE,mBAAmB,EAAE;AACrI,sCAAsC,aAAa,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;AAC9F,2EAA2E,cAAc,EAAE;AAC3F,uCAAuC,eAAe,EAAE,eAAe,EAAE;AACzE,iDAAiD,mBAAmB,EAAE;AACtE,8BAA8B,gBAAgB,EAAE,iBAAiB,EAAE,6BAA6B,EAAE;AAClG;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,6BAA6B;EAC7B,mBAAmB;EACnB,uEAAuE;EACvE,+CAA+C;AACjD;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;AACA,4CAA4C,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AAC9F,2CAA2C,SAAS,EAAE,cAAc,EAAE,eAAe,EAAE;AACvF;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA,sCAAsC,aAAa,EAAE,gDAAgD,EAAE,SAAS,EAAE,oBAAoB,EAAE;AACxI;EACE,YAAY;EACZ,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;AAC9C;AACA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA,sCAAsC,cAAc,EAAE;AACtD,8BAA8B,gBAAgB,EAAE,kBAAkB,EAAE,cAAc,EAAE,eAAe,EAAE,iBAAiB,EAAE;AACxH,6BAA6B,aAAa,EAAE,gDAAgD,EAAE,QAAQ,EAAE;AACxG;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA,sDAAsD,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE,mCAAmC,EAAE;AACvJ,uDAAuD,YAAY,EAAE,mBAAmB,EAAE;AAC1F,mCAAmC,SAAS,EAAE,qBAAqB,EAAE;AACrE,gDAAgD,0CAA0C,EAAE,mBAAmB,EAAE;AACjH,gCAAgC,aAAa,EAAE,SAAS,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,6BAA6B,EAAE;AAC9H,qEAAqE,aAAa,EAAE,YAAY,EAAE,QAAQ,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC/J,4EAA4E,sBAAsB,EAAE,WAAW,EAAE,YAAY,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACpP,wGAAwG,0CAA0C,EAAE,mBAAmB,EAAE;AACzK,kCAAkC,SAAS,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAChG,uDAAuD,cAAc,EAAE;AACvE,qDAAqD,aAAa,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACtG,qCAAqC,gBAAgB,EAAE;AACvD,6BAA6B,aAAa,EAAE,sBAAsB,EAAE,qCAAqC,EAAE,SAAS,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACxJ,mCAAmC,YAAY,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;AAC9G,qEAAqE,cAAc,EAAE;AACrF,oCAAoC,eAAe,EAAE;AACrD,wCAAwC,cAAc,EAAE;AACxD,wBAAwB,cAAc,EAAE;AACxC,qBAAqB,aAAa,EAAE,SAAS,EAAE,gBAAgB,EAAE;AACjE,uBAAuB,aAAa,EAAE,2CAA2C,EAAE,SAAS,EAAE,SAAS,EAAE,kBAAkB,EAAE,8BAA8B,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AACtN,0BAA0B,cAAc,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AACnG,8BAA8B,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,mBAAmB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACpI,qDAAqD,WAAW,EAAE,YAAY,EAAE,SAAS,EAAE,cAAc,EAAE,eAAe,EAAE;AAC5H,+BAA+B,wBAAwB,EAAE;AACzD,qCAAqC,aAAa,EAAE,mBAAmB,EAAE,eAAe,EAAE,SAAS,EAAE,cAAc,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACzJ,sCAAsC,2BAA2B,EAAE,gBAAgB,EAAE;AACrF,8BAA8B,gBAAgB,EAAE;AAChD,4BAA4B,uBAAuB,0BAA0B,EAAE,QAAQ,EAAE,EAAE;AAC3F,4BAA4B,gCAAgC,0BAA0B,EAAE,EAAE;AAC1F,6BAA6B,sCAAsC,gDAAgD,EAAE,EAAE;AACvH;EACE,iCAAiC,0BAA0B,EAAE,SAAS,EAAE,aAAa,EAAE;EACvF,iCAAiC,aAAa,EAAE;EAChD,yCAAyC,sBAAsB,EAAE;EACjE,sCAAsC,0BAA0B,EAAE;AACpE;AACA,wBAAwB,aAAa,EAAE,uBAAuB,EAAE,eAAe,EAAE,SAAS,EAAE,gBAAgB,EAAE;AAC9G,+BAA+B,eAAe,EAAE,kBAAkB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,cAAc,EAAE,eAAe,EAAE,iBAAiB,EAAE;AAC5L,kCAAkC,eAAe,EAAE,kBAAkB,EAAE;AACvE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA,uCAAuC,WAAW,EAAE,YAAY,EAAE,SAAS,EAAE,qBAAqB,EAAE,eAAe,EAAE;AACrH,8CAA8C,yCAAyC,EAAE,mBAAmB,EAAE;AAC9G,qDAAqD,YAAY,EAAE,mBAAmB,EAAE;AACxF,2DAA2D,mBAAmB,EAAE;AAChF,yDAAyD,gBAAgB,EAAE;AAC3E,4BAA4B,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACnH,qBAAqB,WAAW,EAAE,YAAY,EAAE,yBAAyB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,6CAA6C,EAAE;AACzK,6BAA6B,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS,EAAE,eAAe,EAAE;AAC7H,8BAA8B,aAAa,EAAE,QAAQ,EAAE;AACvD,qCAAqC,iBAAiB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,cAAc,EAAE,eAAe,EAAE;AAC7J,8CAA8C,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE,eAAe,EAAE;AAC3H,4BAA4B,KAAK,yBAAyB,EAAE,EAAE","sourcesContent":[".page-container.aluminium-page {\n  width: 100%;\n  max-width: 1600px;\n}\n\n.aluminium-upload-panel {\n  position: relative;\n  z-index: 1;\n}\n\n.aluminium-currency-decision {\n  margin: 0 0 20px;\n  padding: 16px 18px;\n  border: 1px solid #bfdbfe;\n  border-radius: 10px;\n  background: #eff6ff;\n}\n\n.aluminium-currency-decision legend {\n  padding: 0 6px;\n  color: #172033;\n  font-weight: 700;\n}\n\n.aluminium-currency-options,\n.aluminium-currency-conversion {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.aluminium-currency-options label,\n.aluminium-currency-conversion label {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n}\n\n.aluminium-currency-conversion {\n  margin-top: 14px;\n  padding-top: 14px;\n  border-top: 1px solid #bfdbfe;\n}\n\n.aluminium-original-values {\n  margin-bottom: 24px;\n}\n\n.aluminium-notes-editor {\n  display: grid;\n  gap: 7px;\n  max-width: 720px;\n  margin: 10px 0 18px;\n}\n\n.aluminium-notes-editor label {\n  font-weight: 600;\n}\n\n.aluminium-notes-editor textarea {\n  box-sizing: border-box;\n  width: 100%;\n  min-height: 110px;\n  padding: 10px 12px;\n  border: 1px solid #cbd5e1;\n  border-radius: 7px;\n  font: inherit;\n  resize: vertical;\n}\n\n.aluminium-notes-editor small,\n.aluminium-notes-hint {\n  color: #64748b;\n}\n\n.aluminium-converted-original {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 2px;\n  white-space: nowrap;\n}\n\n.aluminium-converted-original small {\n  color: #64748b;\n  font-size: 11px;\n}\n\n.aluminium-automation-title {\n  margin: 0 0 4px;\n  color: #172033;\n}\n\n.aluminium-automation-description {\n  margin: 0 0 18px;\n  color: #64748b;\n  font-size: 14px;\n}\n\n.aluminium-faq h3 {\n  margin: 0 0 14px;\n}\n\n.aluminium-faq details {\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 12px 14px;\n  background: #f8fafc;\n}\n\n.aluminium-faq summary {\n  color: #172033;\n  cursor: pointer;\n  font-weight: 700;\n}\n\n.aluminium-faq p {\n  margin: 12px 0 0;\n  color: #475569;\n}\n\n.aluminium-module-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 20px;\n}\n\n.aluminium-module-header > div:first-child {\n  min-width: 0;\n}\n\n.aluminium-montage-heading {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 20px;\n}\n\n.aluminium-montage-heading h3,\n.aluminium-montage-heading p {\n  margin-top: 0;\n}\n\n.aluminium-montage-heading p {\n  color: #64748b;\n  font-size: 14px;\n}\n\n.aluminium-region-switcher {\n  display: flex;\n  flex: 0 0 auto;\n  gap: 8px;\n}\n\n.aluminium-montage-total {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n  margin: 18px 0;\n  padding: 16px 18px;\n  border-radius: 9px;\n  background: #eff6ff;\n  color: #1e3a8a;\n}\n\n.aluminium-montage-total strong {\n  font-size: 20px;\n}\n\n.aluminium-montage-table-wrap {\n  overflow-x: auto;\n  border: 1px solid #cbd5e1;\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);\n}\n\n.aluminium-montage-table {\n  width: 100%;\n  min-width: 1240px;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 12.5px;\n  font-variant-numeric: tabular-nums;\n}\n\n.aluminium-montage-table caption {\n  padding: 13px 16px;\n  border-bottom: 1px solid #e2e8f0;\n  background: #f8fafc;\n  color: #1e293b;\n  font-size: 14px;\n  font-weight: 700;\n  text-align: left;\n}\n\n.aluminium-montage-table th,\n.aluminium-montage-table td {\n  padding: 12px 10px;\n  border-bottom: 1px solid #e2e8f0;\n  text-align: right;\n  vertical-align: middle;\n}\n\n.aluminium-montage-table thead th {\n  padding-top: 13px;\n  padding-bottom: 13px;\n  border-bottom-color: #1e3a8a;\n  background: #1e3a8a;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.aluminium-montage-table th:first-child,\n.aluminium-montage-table td:first-child,\n.aluminium-montage-table th:nth-child(2),\n.aluminium-montage-table td:nth-child(2),\n.aluminium-montage-table th:nth-child(5),\n.aluminium-montage-table td:nth-child(5),\n.aluminium-montage-table th:nth-child(6),\n.aluminium-montage-table td:nth-child(6) { text-align: left; }\n\n.aluminium-montage-table tbody tr:nth-child(odd) td { background: #fff; }\n.aluminium-montage-table tbody tr:nth-child(even) td { background: #f8fafc; }\n.aluminium-montage-table tbody tr:hover td { background: #eef6ff; }\n.aluminium-montage-table tbody td:first-child {\n  position: sticky;\n  left: 0;\n  z-index: 1;\n  min-width: 74px;\n  box-shadow: inset -1px 0 #e2e8f0;\n}\n.aluminium-montage-table thead th:first-child { position: sticky; left: 0; z-index: 2; }\n.aluminium-montage-table tbody td:first-child strong {\n  display: inline-block;\n  padding: 5px 8px;\n  border-radius: 6px;\n  background: #e8efff;\n  color: #1e40af;\n  font-size: 13px;\n  white-space: nowrap;\n}\n.aluminium-montage-table tbody td:nth-child(10) { color: #0f172a; font-weight: 700; white-space: nowrap; }\n.aluminium-montage-table tbody tr:last-child td { border-bottom: 0; }\n\n.aluminium-montage-table td:first-child small {\n  display: block;\n  margin-top: 4px;\n  color: #64748b;\n  font-size: 11px;\n}\n\n.aluminium-montage-table select {\n  width: 100%;\n  min-width: 110px;\n  min-height: 38px;\n  padding: 7px 9px;\n  border: 1px solid #cbd5e1;\n  border-radius: 7px;\n  background: #fff;\n  color: #172033;\n}\n.aluminium-montage-table input:focus-visible,\n.aluminium-montage-table select:focus-visible { outline: 3px solid rgba(37, 99, 235, 0.2); outline-offset: 2px; }\n.aluminium-montage-table select:disabled { background: #f1f5f9; color: #64748b; }\n\n@media (max-width: 760px) {\n  .aluminium-montage-heading {\n    flex-direction: column;\n  }\n\n  .aluminium-region-switcher {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n}\n\n.aluminium-file-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 9px;\n  box-sizing: border-box;\n  padding: 11px 18px;\n  border: 0;\n  border-radius: 7px;\n  background: #2563eb;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: normal;\n  cursor: pointer;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.12);\n}\n\n.aluminium-file-button:hover {\n  background: #1d4ed8;\n}\n\n.aluminium-file-button:focus-within {\n  outline: 3px solid rgba(37, 99, 235, 0.28);\n  outline-offset: 2px;\n}\n\n.aluminium-file-button.disabled {\n  opacity: 0.65;\n  cursor: wait;\n}\n\n.aluminium-visually-hidden-input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.aluminium-selected-file {\n  max-width: min(420px, 100%);\n  overflow: hidden;\n  color: #334155;\n  font-size: 14px;\n  font-weight: 600;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.aluminium-page-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n}\n\n.aluminium-section-nav {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 10px;\n  margin-bottom: 18px;\n  padding: 8px;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);\n}\n\n.aluminium-section-link {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 9px;\n  min-height: 46px;\n  padding: 10px 14px;\n  border-radius: 8px;\n  color: #475569;\n  font-size: 14px;\n  font-weight: 700;\n  text-align: center;\n  text-decoration: none;\n  transition: background 0.18s ease, color 0.18s ease, box-shadow 0.18s ease;\n}\n\n.aluminium-section-link:hover,\n.aluminium-section-link:focus-visible {\n  background: #eff6ff;\n  color: #1d4ed8;\n  outline: none;\n}\n\n.aluminium-section-link.active {\n  background: #2563eb;\n  color: #fff;\n  box-shadow: 0 3px 9px rgba(37, 99, 235, 0.22);\n}\n\n.aluminium-coming-soon p {\n  margin: 5px 0 18px;\n  color: #64748b;\n  font-size: 14px;\n}\n\n.aluminium-coming-soon-notice {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  margin-bottom: 20px;\n  padding: 18px;\n  border: 1px solid #fde68a;\n  border-radius: 10px;\n  background: #fffbeb;\n  color: #92400e;\n}\n\n.aluminium-coming-soon-notice > svg {\n  width: 28px;\n  height: 28px;\n  flex: 0 0 auto;\n}\n\n.aluminium-coming-soon-notice div {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.aluminium-coming-soon-notice span {\n  font-size: 14px;\n}\n\n.aluminium-changes-notice {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin: 0 0 20px;\n  padding: 14px 16px;\n  border: 1px solid #fecaca;\n  border-left: 4px solid #dc2626;\n  border-radius: 9px;\n  background: #fef2f2;\n  color: #7f1d1d;\n  box-shadow: 0 2px 7px rgba(127, 29, 29, 0.06);\n}\n\n.aluminium-changes-notice > svg {\n  width: 20px;\n  height: 20px;\n  flex: 0 0 auto;\n  margin-top: 1px;\n  color: #dc2626;\n}\n\n.aluminium-changes-notice > div {\n  min-width: 0;\n}\n\n.aluminium-changes-notice strong {\n  display: block;\n  color: #b91c1c;\n  font-size: 15px;\n  line-height: 1.3;\n}\n\n.aluminium-changes-notice time {\n  display: inline-block;\n  margin-top: 5px;\n  padding: 2px 7px;\n  border-radius: 5px;\n  background: #fee2e2;\n  color: #991b1b;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.aluminium-changes-notice span {\n  display: block;\n  margin-top: 8px;\n  color: #991b1b;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.aluminium-changes-notice ul {\n  margin: 5px 0 0;\n  padding-left: 20px;\n  color: #991b1b;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.aluminium-changes-notice li + li {\n  margin-top: 3px;\n}\n\n.aluminium-coming-soon button:disabled {\n  opacity: 0.55;\n  cursor: not-allowed !important;\n}\n\n.aluminium-instruction-actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.aluminium-instruction-button,\n.aluminium-instruction-download {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px 14px;\n  border: 1px solid #2563eb;\n  border-radius: 7px;\n  background: #fff;\n  color: #1d4ed8;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 700;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.aluminium-instruction-button:hover,\n.aluminium-instruction-download:hover {\n  background: #eff6ff;\n}\n\n.aluminium-instruction-button:disabled,\n.aluminium-instruction-download:disabled {\n  border-color: #cbd5e1;\n  background: #f1f5f9;\n  color: #64748b;\n  cursor: not-allowed;\n}\n\n.aluminium-instruction-overlay {\n  position: fixed;\n  z-index: 11000;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(15, 23, 42, 0.68);\n}\n\n.aluminium-instruction-modal {\n  display: flex;\n  flex-direction: column;\n  width: min(1100px, 96vw);\n  height: min(900px, 92vh);\n  overflow: hidden;\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.35);\n}\n\n.aluminium-instruction-modal-header,\n.aluminium-instruction-modal-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 14px 18px;\n}\n\n.aluminium-instruction-modal-header {\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.aluminium-instruction-modal-header h3 {\n  margin: 0;\n}\n\n.aluminium-instruction-modal-footer {\n  justify-content: flex-end;\n  border-top: 1px solid #e2e8f0;\n}\n\n.aluminium-instruction-close {\n  width: 38px;\n  height: 38px;\n  border: 0;\n  border-radius: 50%;\n  background: #f1f5f9;\n  color: #334155;\n  font-size: 26px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.aluminium-instruction-close:hover {\n  background: #e2e8f0;\n}\n\n.aluminium-instruction-frame {\n  width: 100%;\n  flex: 1;\n  border: 0;\n  background: #f8fafc;\n}\n\n.aluminium-changed-toast {\n  position: fixed;\n  z-index: 10000;\n  top: 86px;\n  left: 50%;\n  transform: translateX(-50%);\n  min-width: 180px;\n  padding: 14px 24px;\n  border-radius: 10px;\n  background: #15803d;\n  color: #fff;\n  box-shadow: 0 10px 28px rgba(21, 128, 61, 0.28);\n  text-align: center;\n  font-size: 17px;\n  font-weight: 800;\n  animation: aluminium-toast-in 0.2s ease-out;\n}\n\n@keyframes aluminium-toast-in {\n  from { opacity: 0; transform: translate(-50%, -10px); }\n  to { opacity: 1; transform: translate(-50%, 0); }\n}\n\n.aluminium-config-panel {\n  min-width: 0;\n}\n\n.aluminium-mode-switcher {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(180px, 1fr));\n  gap: 12px;\n  margin: 22px 0 16px;\n}\n\n.aluminium-workflow-switcher {\n  grid-template-columns: repeat(2, minmax(220px, 1fr));\n}\n\n.aluminium-config-panel {\n  display: flex;\n  flex-direction: column;\n}\n\n.aluminium-workflow-content {\n  order: 1;\n}\n\n.aluminium-original-values-summary {\n  order: 2;\n}\n\n.aluminium-workflow-details {\n  order: 3;\n}\n\n.aluminium-config-panel > .aluminium-inline-preview {\n  order: 4;\n}\n\n.aluminium-pricing-step {\n  margin-top: 22px;\n  padding: 22px;\n  border: 1px solid #dbe4f0;\n  border-radius: 12px;\n  background: #fff;\n}\n\n.aluminium-step-heading {\n  display: flex;\n  align-items: baseline;\n  gap: 12px;\n}\n\n.aluminium-step-heading span {\n  padding: 5px 9px;\n  border-radius: 999px;\n  background: #dbeafe;\n  color: #1d4ed8;\n  font-size: 12px;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.aluminium-step-heading h3 {\n  margin: 0;\n}\n\n.aluminium-pricing-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 16px;\n}\n\n.aluminium-mode-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 9px;\n  min-height: 58px;\n  padding: 12px 16px;\n  border: 2px solid #d7e0ec;\n  border-radius: 10px;\n  background: #f8fafc;\n  color: #263447;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.aluminium-mode-button:hover {\n  border-color: #8eacf8;\n  background: #f1f5ff;\n}\n\n.aluminium-mode-button.active {\n  border-color: #2563eb;\n  background: #eaf1ff;\n  color: #1747b7;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);\n}\n\n.aluminium-value-controls {\n  display: flex;\n  justify-content: center;\n  align-items: end;\n  flex-wrap: wrap;\n  gap: 20px;\n  padding: 14px;\n  border-radius: 10px;\n  background: #f8fafc;\n}\n\n.aluminium-value-controls label {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  font-weight: 700;\n}\n\n.aluminium-discount-controls {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 14px;\n}\n\n.aluminium-discount-controls label {\n  justify-content: center;\n  min-width: 0;\n  white-space: nowrap;\n}\n\n.aluminium-discount-controls input,\n.aluminium-discount-controls select {\n  box-sizing: border-box;\n  width: 108px;\n  max-width: none !important;\n  height: 38px;\n  flex: 0 0 108px;\n  background: #fff;\n}\n\n.aluminium-discount-controls .aluminium-exchange-rate {\n  gap: 7px;\n}\n\n.aluminium-discount-controls .aluminium-exchange-rate select {\n  width: 88px;\n  flex-basis: 88px;\n}\n\n.aluminium-auto-discount {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  width: fit-content;\n  margin: 18px auto 6px;\n  padding: 12px 14px 12px 20px;\n  border: 1px solid #b9cdfc;\n  border-radius: 11px;\n  background: #f3f7ff;\n  color: #263447;\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.aluminium-auto-discount strong {\n  min-width: 112px;\n  padding: 9px 14px;\n  border-radius: 7px;\n  background: #2563eb;\n  color: #fff;\n  text-align: center;\n  font-size: 19px;\n  letter-spacing: 0.02em;\n}\n\n.aluminium-auto-markup {\n  border-color: #bbf7d0;\n  background: #f0fdf4;\n}\n\n.aluminium-auto-markup strong {\n  background: #15803d;\n}\n\n.aluminium-inline-preview {\n  margin-top: 28px;\n  padding-top: 24px;\n  border-top: 1px solid #e2e8f0;\n}\n\n.aluminium-result-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 14px;\n}\n\n.aluminium-finish-button {\n  padding: 11px 22px;\n  border: 1px solid #94a3b8;\n  border-radius: 7px;\n  background: #fff;\n  color: #334155;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.aluminium-finish-button:hover {\n  border-color: #64748b;\n  background: #f1f5f9;\n}\n\n.aluminium-pdf-frame {\n  display: block;\n  width: 100%;\n  height: min(76vh, 900px);\n  min-height: 620px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #f8fafc;\n}\n\n@media (max-width: 1350px) {\n  .aluminium-pdf-frame {\n    height: 720px;\n  }\n}\n\n@media (max-width: 700px) {\n  .aluminium-section-nav {\n    grid-template-columns: 1fr;\n  }\n\n  .aluminium-section-link {\n    justify-content: flex-start;\n  }\n\n  .aluminium-page-header,\n  .aluminium-module-header,\n  .aluminium-instruction-actions {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .aluminium-instruction-overlay {\n    padding: 8px;\n  }\n\n  .aluminium-instruction-modal {\n    width: 100%;\n    height: 96vh;\n  }\n\n  .aluminium-result-actions {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .aluminium-mode-switcher {\n    grid-template-columns: 1fr;\n  }\n\n  .aluminium-pricing-step {\n    padding: 14px;\n  }\n\n  .aluminium-pricing-actions {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .aluminium-auto-discount {\n    width: 100%;\n    flex-direction: column;\n    padding: 14px;\n  }\n\n  .aluminium-pdf-frame {\n    height: 560px;\n    min-height: 0;\n  }\n}\n.aluminium-dimensions { display: flex; align-items: center; gap: 5px; min-width: 190px; }\n.aluminium-dimensions input { box-sizing: border-box; width: 82px; min-height: 38px; padding: 7px; border: 1px solid #cbd5e1; border-radius: 6px; }\n.aluminium-dimensions.requires-review input { border-color: #f59e0b; background: #fffbeb; box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.16); }\n.aluminium-dimensions-warning { display: block; margin-top: 4px; color: #b45309; font-size: 11px; font-weight: 700; text-align: left; }\n.aluminium-montage-table select.requires-selection { border-color: #dc2626; background: #fef2f2; color: #991b1b; font-weight: 700; }\n.aluminium-montage-table input.requires-selection { border-color: #dc2626; background: #fef2f2; color: #991b1b; font-weight: 700; }\n.aluminium-quantity-input { box-sizing: border-box; width: 64px; min-height: 38px; padding: 7px; border: 1px solid #cbd5e1; border-radius: 6px; text-align: right; }\n.aluminium-montage-table td:nth-child(7) .aluminium-quantity-input { width: 94px; }\n.aluminium-row-actions { display: flex; justify-content: flex-end; gap: 6px; flex-wrap: wrap; min-width: 80px; }\n.aluminium-row-actions button { border: 1px solid #2563eb; border-radius: 6px; padding: 6px 8px; background: #eff6ff; color: #1d4ed8; cursor: pointer; white-space: nowrap; }\n.aluminium-row-actions button:hover:not(:disabled) { background: #dbeafe; }\n.aluminium-row-actions button:focus-visible { outline: 3px solid rgba(37, 99, 235, 0.25); outline-offset: 2px; }\n.aluminium-row-actions button:disabled { opacity: 0.5; cursor: not-allowed; }\n.aluminium-row-actions button.add { width: 30px; height: 30px; padding: 0; font-size: 20px; line-height: 1; font-weight: 700; }\n.aluminium-row-actions button.remove { border-color: #dc2626; background: #fef2f2; color: #b91c1c; }\n.aluminium-row-actions button.remove:hover:not(:disabled) { background: #fee2e2; }\n.aluminium-montage-table tbody tr.aluminium-service-row td { background: #eef2ff; color: #334155; }\n.aluminium-montage-table tbody tr.aluminium-service-row:hover td { background: #e0e7ff; }\n.aluminium-montage-table tbody tr.aluminium-service-row td:first-child strong { background: #dbeafe; }\n.aluminium-montage-table tbody tr.aluminium-position-start td { border-top: 2px solid #bfdbfe; }\n.aluminium-montage-summary-title { margin: 20px 0 10px; }\n.aluminium-common-installation {\n  position: relative;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(260px, 360px);\n  align-items: center;\n  gap: 24px;\n  margin: 8px 0 22px;\n  padding: 20px 24px;\n  overflow: hidden;\n  border: 1px solid #bfdbfe;\n  border-radius: 14px;\n  background: linear-gradient(110deg, #eff6ff 0%, #f8fbff 72%, #fff 100%);\n  box-shadow: 0 8px 24px rgba(30, 64, 175, 0.07);\n}\n.aluminium-common-installation::before {\n  position: absolute;\n  inset: 0 auto 0 0;\n  width: 5px;\n  background: #2563eb;\n  content: '';\n}\n.aluminium-common-installation h4 { margin: 0 0 6px; color: #1e3a8a; font-size: 18px; }\n.aluminium-common-installation p { margin: 0; color: #475569; font-size: 13px; }\n.aluminium-common-installation-field { display: grid; min-width: 0; gap: 7px; }\n.aluminium-common-installation label { color: #334155; font-size: 13px; font-weight: 700; }\n.aluminium-common-installation select {\n  width: 100%;\n  min-height: 44px;\n  padding: 9px 12px;\n  border: 1px solid #93c5fd;\n  border-radius: 9px;\n  background: #fff;\n  color: #172033;\n  font: inherit;\n  font-weight: 600;\n}\n.aluminium-common-installation select:focus-visible { outline: 3px solid rgba(37, 99, 235, 0.25); outline-offset: 2px; }\n.aluminium-mixed-construction-alert {\n  margin: 18px 0;\n  padding: 16px 18px;\n  border: 1px solid #fca5a5;\n  border-left: 5px solid #dc2626;\n  border-radius: 10px;\n  background: #fef2f2;\n  color: #991b1b;\n  line-height: 1.5;\n}\n.aluminium-mixed-construction-alert > strong { display: block; margin-bottom: 8px; font-size: 15px; }\n.aluminium-mixed-construction-alert ul { margin: 0; padding-left: 20px; }\n.aluminium-mixed-construction-alert li + li { margin-top: 8px; }\n.aluminium-montage-legend {\n  display: flex;\n  align-items: center;\n  gap: 10px 18px;\n  flex-wrap: wrap;\n  margin: 12px 0 0;\n  padding: 10px 14px;\n  border: 1px solid #cbd5e1;\n  border-radius: 9px;\n  background: #f8fafc;\n  color: #334155;\n  font-size: 13px;\n}\n.aluminium-montage-legend span { display: inline-flex; align-items: center; gap: 6px; }\n.aluminium-montage-legend code { padding: 2px 6px; border-radius: 5px; background: #e0e7ff; color: #1e40af; font-weight: 700; }\n.aluminium-montage-legend small { color: #64748b; }\n.aluminium-montage-financials { display: grid; grid-template-columns: repeat(3, minmax(140px, 1fr)); gap: 12px; margin-bottom: 18px; }\n.aluminium-montage-financials > div { padding: 14px; border-radius: 9px; background: #f1f5f9; }\n.aluminium-montage-financials span, .aluminium-montage-financials strong { display: block; }\n.aluminium-montage-financials strong { margin-top: 4px; font-size: 18px; }\n.aluminium-montage-financials.discounted > div { background: #ecfdf5; }\n.aluminium-montage-discount { margin-top: 24px; padding-top: 20px; border-top: 2px solid #cbd5e1; }\n.aluminium-additional-services {\n  margin-top: 26px;\n  padding: 22px;\n  border: 1px solid #a5b4fc;\n  border-top: 4px solid #4f46e5;\n  border-radius: 14px;\n  background: linear-gradient(180deg, #eef2ff 0%, #f8faff 30%, #fff 100%);\n  box-shadow: 0 10px 28px rgba(49, 46, 129, 0.09);\n}\n.aluminium-additional-services-heading {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 18px;\n}\n.aluminium-additional-services-heading h4 { margin: 0 0 5px; color: #312e81; font-size: 19px; }\n.aluminium-additional-services-heading p { margin: 0; color: #475569; font-size: 13px; }\n.aluminium-additional-services-heading > span {\n  flex: 0 0 auto;\n  padding: 5px 9px;\n  border: 1px solid #c7d2fe;\n  border-radius: 999px;\n  background: #fff;\n  color: #4338ca;\n  font-size: 12px;\n  font-weight: 700;\n}\n.aluminium-additional-services-grid { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 12px; align-items: stretch; }\n.aluminium-additional-services .aluminium-service-card {\n  min-width: 0;\n  margin: 0;\n  padding: 14px;\n  border: 1px solid #dbe3f0;\n  border-radius: 11px;\n  background: #fff;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);\n}\n.aluminium-additional-services .aluminium-service-card legend {\n  max-width: 100%;\n  padding: 0 5px;\n  color: #1e293b;\n  font-size: 14px;\n  font-weight: 750;\n}\n.aluminium-service-card legend span { color: #4f46e5; }\n.aluminium-service-card > p { min-height: 34px; margin: 4px 0 14px; color: #64748b; font-size: 12px; line-height: 1.45; }\n.aluminium-service-options { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 7px; }\n.aluminium-service-included {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 38px;\n  padding: 6px 8px;\n  border: 1px solid #86efac;\n  border-radius: 8px;\n  background: #f0fdf4;\n  color: #166534;\n  font-size: 13px;\n  font-weight: 700;\n}\n.aluminium-additional-services .aluminium-service-options label {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  min-height: 38px;\n  padding: 6px 8px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #f8fafc;\n  color: #334155;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.aluminium-service-options label:has(input:checked) { border-color: #6366f1; background: #eef2ff; color: #3730a3; box-shadow: inset 0 0 0 1px #6366f1; }\n.aluminium-service-options label:has(input:disabled) { opacity: 0.5; cursor: not-allowed; }\n.aluminium-service-options input { margin: 0; accent-color: #4f46e5; }\n.aluminium-service-options label:focus-within { outline: 3px solid rgba(99, 102, 241, 0.2); outline-offset: 2px; }\n.aluminium-transport-controls { display: grid; gap: 10px; margin-top: 14px; padding-top: 14px; border-top: 1px solid #e2e8f0; }\n.aluminium-additional-services .aluminium-transport-controls label { display: grid; min-width: 0; gap: 5px; color: #334155; font-size: 12px; font-weight: 700; }\n.aluminium-transport-controls select, .aluminium-transport-controls input { box-sizing: border-box; width: 100%; min-width: 0; min-height: 38px; padding: 7px 9px; border: 1px solid #cbd5e1; border-radius: 7px; background: #fff; color: #172033; }\n.aluminium-transport-controls select:focus-visible, .aluminium-transport-controls input:focus-visible { outline: 3px solid rgba(99, 102, 241, 0.2); outline-offset: 2px; }\n.aluminium-transport-controls p { margin: 0; color: #64748b; font-size: 12px; line-height: 1.5; }\n.aluminium-transport-controls p.aluminium-form-error { color: #b91c1c; }\n.aluminium-service-card > p.aluminium-service-hint { min-height: 0; margin: 12px 0 0; color: #92400e; }\n.aluminium-additional-services > p { margin: 14px 0 0; }\n.aluminium-service-summary { display: grid; grid-auto-flow: column; grid-auto-columns: minmax(180px, 1fr); gap: 12px; overflow-x: auto; margin: 14px 0; }\n.aluminium-service-summary > div { min-width: 0; padding: 12px 14px; border-radius: 8px; background: #f1f5f9; }\n.aluminium-service-summary span, .aluminium-service-summary strong { display: block; }\n.aluminium-service-summary strong { margin-top: 4px; }\n.aluminium-montage-effective-discount { color: #166534; }\n.aluminium-form-error { color: #b91c1c; }\n.aluminium-updates { display: grid; gap: 10px; margin-top: 12px; }\n.aluminium-updates p { display: grid; grid-template-columns: 155px minmax(0, 1fr); gap: 12px; margin: 0; padding: 10px 12px; border-left: 3px solid #2563eb; border-radius: 6px; background: #f8fafc; color: #334155; }\n.aluminium-updates time { color: #64748b; font-size: 0.9em; font-weight: 700; white-space: nowrap; }\n.aluminium-recipient-option { display: flex; align-items: center; gap: 10px; margin: 12px 0 24px; color: #334155; font-size: 0.9em; }\n.aluminium-recipient-option input[type=\"checkbox\"] { width: 22px; height: 22px; margin: 0; flex: 0 0 22px; cursor: pointer; }\n.aluminium-discount-language { margin: -8px 0 24px 32px; }\n.aluminium-discount-language label { display: flex; align-items: center; flex-wrap: wrap; gap: 10px; color: #334155; font-size: 0.9em; font-weight: 700; }\n.aluminium-discount-language select { max-width: 310px !important; background: #fff; }\n.aluminium-discount-summary { margin-top: 24px; }\n@media (max-width: 600px) { .aluminium-updates p { grid-template-columns: 1fr; gap: 4px; } }\n@media (max-width: 640px) { .aluminium-montage-financials { grid-template-columns: 1fr; } }\n@media (max-width: 1200px) { .aluminium-additional-services-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); } }\n@media (max-width: 700px) {\n  .aluminium-common-installation { grid-template-columns: 1fr; gap: 14px; padding: 18px; }\n  .aluminium-additional-services { padding: 18px; }\n  .aluminium-additional-services-heading { flex-direction: column; }\n  .aluminium-additional-services-grid { grid-template-columns: 1fr; }\n}\n.aluminium-export-row { display: flex; align-items: flex-start; flex-wrap: wrap; gap: 12px; margin-top: 18px; }\n.aluminium-export-validation { flex: 1 1 320px; padding: 10px 14px; border: 1px solid #fecaca; border-radius: 8px; background: #fef2f2; color: #991b1b; font-size: 13px; line-height: 1.45; }\n.aluminium-export-validation ul { margin: 6px 0 0; padding-left: 18px; }\n.aluminium-pdf-discount-option {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 18px;\n  padding: 11px 14px;\n  border: 1px solid #cbd5e1;\n  border-radius: 9px;\n  background: #f8fafc;\n  color: #1e293b;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n.aluminium-pdf-discount-option input { width: 18px; height: 18px; margin: 0; accent-color: #2563eb; cursor: pointer; }\n.aluminium-pdf-discount-option:focus-within { outline: 3px solid rgba(37, 99, 235, 0.2); outline-offset: 2px; }\n.aluminium-pdf-discount-option:has(input:disabled) { opacity: 0.6; cursor: not-allowed; }\n.aluminium-pdf-discount-option:has(input:disabled) input { cursor: not-allowed; }\n.aluminium-pdf-discount-option + .aluminium-export-row { margin-top: 12px; }\n.aluminium-export-loading { display: inline-flex; align-items: center; gap: 8px; color: #1d4ed8; font-weight: 600; }\n.aluminium-spinner { width: 17px; height: 17px; border: 2px solid #bfdbfe; border-top-color: #2563eb; border-radius: 50%; animation: aluminium-spin .8s linear infinite; }\n.aluminium-preview-heading { display: flex; align-items: center; justify-content: space-between; gap: 12px; flex-wrap: wrap; }\n.aluminium-preview-switcher { display: flex; gap: 8px; }\n.aluminium-preview-switcher button { padding: 7px 10px; border: 1px solid #2563eb; border-radius: 6px; background: #eff6ff; color: #1d4ed8; cursor: pointer; }\n.aluminium-preview-switcher button:disabled { border-color: #cbd5e1; background: #f1f5f9; color: #64748b; cursor: default; }\n@keyframes aluminium-spin { to { transform: rotate(360deg); } }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
